globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.AppointmentController = (function(superClass) {

    utils.extend(AppointmentController, superClass);

    function AppointmentController() {
        return AppointmentController.__super__.constructor.apply(this, arguments);
    }

    $.extend(AppointmentController.prototype, {
        init: function(){
            this.initEvents();

            return AppointmentController.__super__.init.apply(this, arguments);
        },
        initEvents: function(){
            $('.calendly-widget').on('calendly_event_scheduled', function(){
                $(".btn-appointment-not-submitted").hide();
                $(".btn-appointment-submitted").show();
            });
        }
    });

    return AppointmentController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
